import React from "react";

export const PasswordIcon = ({ width = 24, height = 24, color = "#000000", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.50011 18.5V17.5H21.5001V18.5H2.50011ZM3.03511 12.527L2.27311 12.085L3.23811 10.392H1.30811V9.50797H3.23811L2.27311 7.86597L3.03511 7.42297L4.00011 9.06597L4.96611 7.42297L5.72711 7.86597L4.76211 9.50797H6.69211V10.392H4.76211L5.72711 12.085L4.96511 12.527L4.00011 10.835L3.03511 12.527ZM11.0351 12.527L10.2731 12.085L11.2391 10.392H9.3081V9.50797H11.2381L10.2731 7.86597L11.0351 7.42297L12.0001 9.06597L12.9661 7.42297L13.7271 7.86597L12.7621 9.50797H14.6921V10.392H12.7621L13.7271 12.085L12.9651 12.527L12.0001 10.835L11.0351 12.527ZM19.0351 12.527L18.2731 12.085L19.2391 10.392H17.3081V9.50797H19.2381L18.2731 7.86597L19.0351 7.42297L20.0001 9.06597L20.9661 7.42297L21.7271 7.86597L20.7621 9.50797H22.6921V10.392H20.7621L21.7271 12.085L20.9651 12.527L20.0001 10.835L19.0351 12.527Z"
        fill={color}
      />
    </svg>
  );
};
